import i18n from 'i18next';
import detector from 'i18next-browser-languagedetector';
import { initReactI18next } from 'react-i18next';
import nl from './locales/nl/default.json';
import nlnl from './locales/nl/nlNL.json';
import nlbe from './locales/nl/nlBE.json';
import de from './locales/de/translations.json';
import en from './locales/en/translations.json';
import frfr from './locales/fr-FR/translations.json';
import ptpt from './locales/pt-PT/translations.json';

// the translations
// (tip move them in a JSON file and import them,
// or even better, manage them separated from your code: https://react.i18next.com/guides/multiple-translation-files)
const resources = {
  nl: { translation: nl },
  'nl-BE': { translation: nlbe },
  'nl-NL': { translation: nlnl },
  de: { translation: de },
  en: { translation: en },
  'fr-FR': { translation: frfr },
  'pt-PT': { translation: ptpt },
};

i18n
  .use(detector)
  .use(initReactI18next) // passes i18n down to react-i18next
  .init({
    resources,
    fallbackLng: 'nl', // language to use, more information here: https://www.i18next.com/overview/configuration-options#languages-namespaces-resources
    // you can use the i18n.changeLanguage function to change the language manually: https://www.i18next.com/overview/api#changelanguage
    // if you're using a language detector, do not define the lng option
    detection: {
      order: ['querystring'],
      lookupQuerystring: 'ui_locales',
    },
    interpolation: {
      escapeValue: false, // react already safes from xss
    },
  });

/** The detector runs before `initAuth` restores the original URL, so re-read `ui_locales` after. */
export function syncLanguageFromUrl(): void {
  const requested = new URLSearchParams(window.location.search).get('ui_locales');
  const resolved = requested && resolveSupportedLanguage(requested);
  if (resolved && resolved !== i18n.language) i18n.changeLanguage(resolved);
}

/** `fr_FR` and `fr` both mean the registered `fr-FR`. */
function resolveSupportedLanguage(tag: string): string | undefined {
  const available = Object.keys(resources);
  const normalized = tag.trim().replace('_', '-');
  const exact = available.find((lng) => lng.toLowerCase() === normalized.toLowerCase());
  if (exact) return exact;

  const base = normalized.split('-')[0].toLowerCase();
  return available.find(
    (lng) => lng.toLowerCase() === base || lng.toLowerCase().startsWith(`${base}-`)
  );
}

export default i18n;
